export function timeToString(timestamp) {

  if (!timestamp) {
    return ""
  }
  const now = new Date();
  const timeDifference = now - new Date(timestamp);

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days}d ${hours % 24}h ${minutes % 60}m ${seconds % 60}s ago`;
  } else if (hours > 0) {
    return `${hours}h ${minutes % 60}m ${seconds % 60}s ago`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s ago`;
  } else {
    return `${seconds}s ago`;
  }
}